export const hotjarTrigger = (trigger, tags = []) => {
  window.hj =
    window.hj ||
    function() {
      window.hj.q = window.hj.q || []
      window.hj.q.push(arguments)
    }

  window.hj('tagRecording', tags)
  window.hj('trigger', trigger)
}
